import React, { useState, useEffect } from 'react';
import { db } from '../firebase'; 
import { collection, addDoc, onSnapshot, query, orderBy, updateDoc, doc } from 'firebase/firestore';

const SOFOR_EMAILLERI = {
  "OSMAN": "osman@gmail.com",
  "MUSTAFA": "mustafatarkanc@gmail.com",
  "SAMPSON": "karayelkarayel605@gmail.com",
  "ÜMİT KARDEŞOĞLU": "u.kardesoglu@gmail.com"
};

const KKTC_LISTE = {
  "LEFKOŞA": ["LEFKOŞA MERKEZ", "ALAYKÖY", "BALIKESİR", "DEĞİRMENLİK", "DEMİRHAN", "DİLEKKAYA", "GÖNYELİ", "HAMİTKÖY", "HASPOLAT", "MİNARELİKÖY", "YENİCEKÖY", "YILMAZKÖY"],
  "GAZİMAĞUSA": ["GAZİMAĞUSA MERKEZ", "AKDOĞAN", "BEYARMUDU", "GEÇİTKALE", "İNÖNÜ", "PAŞAKÖY", "TATLISU", "VADİLİ", "YENİBOĞAZİÇİ"],
  "GİRNE": ["GİRNE MERKEZ", "ALSANCAK", "BELLAPAİS", "ÇATALKÖY", "DİKMEN", "ESENTEPE", "KARAOĞLANOĞLU", "LAPTA", "OZANKÖY", "ZEYTİNLİK"],
  "İSKELE": ["İSKELE MERKEZ", "BAFRA", "BOĞAZ", "DİPKARPAZ", "MEHMETÇİK", "YENİ ERENKÖY", "ZİYAMET"],
  "GÜZELYURT": ["GÜZELYURT MERKEZ", "AKÇAY", "AYDINKÖY", "BOSTANCI", "KALKANLI", "ZÜMRÜTKÖY"],
  "LEFKE": ["LEFKE MERKEZ", "DENİZLİ", "GAZİVEREN", "GEMİKONAĞI", "YEDİDALGA", "YEŞİLYURT"]
};

function DevayKargoPage() {
  const [view, setView] = useState("LISTE");
  const [siparisler, setSiparisler] = useState([]);
  const [aktifFiltre, setAktifFiltre] = useState("HEPSİ");
  const [seciliKargo, setSeciliKargo] = useState(null);
  const [editingId, setEditingId] = useState(null);
  
  // Ana Form State
  const [form, setForm] = useState({
    adSoyad: "", ilce: "", koy: "", adres: "", tel: "", paketAdet: "1", aciklama: "", tutar: "", kargoUcreti: "0"
  });

  // Mağaza Satış State (Basit Form)
  const [magazaForm, setMagazaForm] = useState({
    adSoyad: "", aciklama: "", tutar: "", tahsilatTipi: "NAKİT"
  });

  useEffect(() => {
    const q = query(collection(db, "kargolar"), orderBy("tarih", "desc"));
    const unsubscribe = onSnapshot(q, (snap) => {
      setSiparisler(snap.docs.map(doc => ({ ...doc.data(), id: doc.id })));
    });
    return () => unsubscribe();
  }, []);

  const etiketBas = (kargo) => {
    const printWindow = window.open('', '_blank', 'width=600,height=400');
    const toplamTutar = (Number(kargo.tutar || 0) + Number(kargo.kargoUcreti || 0));
    
    printWindow.document.write(`
      <html>
        <head>
          <title>Etiket - ${kargo.adSoyad}</title>
          <style>
            @page { size: 100mm 100mm; margin: 0; }
            body { font-family: sans-serif; padding: 15px; text-transform: uppercase; margin: 0; }
            .card { border: 2px solid #000; padding: 10px; height: 350px; display: flex; flex-direction: column; justify-content: space-between; box-sizing: border-box; }
            .header { border-bottom: 2px solid #000; padding-bottom: 5px; display: flex; justify-content: space-between; align-items: center; }
            .title { font-size: 10px; font-weight: bold; color: #444; margin-top: 5px; }
            .text { font-size: 16px; font-weight: 900; margin-bottom: 2px; }
            .address { font-size: 13px; font-weight: bold; line-height: 1.2; height: 45px; overflow: hidden; }
            .footer { border-top: 1px solid #000; padding-top: 8px; display: flex; justify-content: space-between; align-items: flex-end; }
            .price { font-size: 32px; font-weight: 900; }
          </style>
        </head>
        <body>
          <div class="card">
            <div class="header">
              <div style="font-weight:900; font-size:18px;">DEVAY KARGO</div>
              <div style="font-size:11px;">${new Date(kargo.tarih).toLocaleDateString('tr-TR')}</div>
            </div>
            <div>
              <div class="title">ALICI:</div>
              <div class="text">${kargo.adSoyad}</div>
              <div class="title">BÖLGE / ADRES:</div>
              <div class="address">${kargo.ilce || 'MAĞAZA'} / ${kargo.koy || '-'}<br/>${kargo.adres || 'ELDEN TESLİM'}</div>
              <div class="title">TELEFON:</div>
              <div class="text">${kargo.tel || '-'}</div>
            </div>
            <div style="font-size:9px; font-weight:bold;">İÇERİK: ${kargo.aciklama || '-'}</div>
            <div class="footer">
              <div>
                <div class="title">KAPIDA ÖDEME:</div>
                <div class="price">${toplamTutar} TL</div>
              </div>
              <div style="text-align:right;">
                <div style="font-size:10px; font-weight:900;">PAKET: ${kargo.paketAdet || 1}</div>
                <div style="background:#000; color:#fff; padding:3px 8px; font-size:12px; font-weight:900; margin-top:5px;">DEVAY</div>
              </div>
            </div>
          </div>
          <script>window.onload = function() { window.print(); window.close(); }</script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const kargoKaydet = async () => {
    if (!form.adSoyad || !form.ilce) return alert("EKSİK BİLGİ!");
    try {
      if (editingId) {
        await updateDoc(doc(db, "kargolar", editingId), { ...form });
        setEditingId(null);
      } else {
        await addDoc(collection(db, "kargolar"), {
          ...form, 
          durum: "BEKLEYEN",
          tarih: new Date().toISOString(), 
          atananPersonel: "",
          atananEmail: "",
          atananPlaka: ""
        });
      }
      setForm({ adSoyad: "", ilce: "", koy: "", adres: "", tel: "", paketAdet: "1", aciklama: "", tutar: "", kargoUcreti: "0" });
      setView("LISTE");
    } catch (error) {
      alert("Hata oluştu: " + error.message);
    }
  };

  const magazaSatisiKaydet = async () => {
    if (!magazaForm.tutar) return alert("LÜTFEN TUTAR GİRİNİZ!");
    try {
      await addDoc(collection(db, "kargolar"), {
        adSoyad: magazaForm.adSoyad || "MAĞAZA MÜŞTERİSİ",
        aciklama: magazaForm.aciklama,
        tutar: magazaForm.tutar,
        tahsilatTipi: magazaForm.tahsilatTipi,
        durum: "TESLİM EDİLDİ",
        teslimSekli: "MAĞAZA",
        tarih: new Date().toISOString(),
        atananPersonel: "MAĞAZA",
        ilce: "MAĞAZA",
        koy: "ELDEN",
        kargoUcreti: "0",
        paketAdet: "1"
      });
      alert("Mağaza Satışı Kaydedildi!");
      setMagazaForm({ adSoyad: "", aciklama: "", tutar: "", tahsilatTipi: "NAKİT" });
      setView("LISTE");
    } catch (error) {
      alert("Hata: " + error.message);
    }
  };

  const kargoIptalEt = async (kargo) => {
    const neden = prompt("İptal/İade nedenini yazınız:");
    if (neden === null) return; 
    if (neden.trim() === "") return alert("Bir neden yazmalısınız!");
    const yeniAciklama = `${kargo.aciklama || ""} [İPTAL NEDENİ: ${neden.toUpperCase()}]`;
    await updateDoc(doc(db, "kargolar", kargo.id), { 
        durum: "İADE",
        aciklama: yeniAciklama,
        atananPersonel: "",
        atananEmail: "",
        atananPlaka: ""
    });
  };

  const kargoDuzenle = (kargo) => {
    setForm({ ...kargo });
    setEditingId(kargo.id);
    setView("EKLE");
  };

  const soforeAta = async (sofor, plaka) => {
    await updateDoc(doc(db, "kargolar", seciliKargo.id), {
      atananPersonel: sofor,
      atananPlaka: plaka,
      atananEmail: SOFOR_EMAILLERI[sofor] || "",
      durum: "BEKLEYEN"
    });
    setSeciliKargo(null);
    setView("LISTE");
  };

  const filtrelenmişList = (siparisler || []).filter(s => 
    aktifFiltre === "HEPSİ" ? true : s.durum === aktifFiltre
  );

  return (
    <div className="min-h-screen bg-[#f8fafc] text-slate-900 flex flex-col pb-24 font-sans">
      
      {/* LOGO BAR */}
      <div className="p-6 bg-white border-b border-green-100 flex justify-between items-center sticky top-0 z-50 shadow-sm">
        <div>
            <h1 className="text-green-700 font-black italic text-xl tracking-tighter uppercase leading-none">Devay <span className="text-slate-400 font-light tracking-normal">Kargo</span></h1>
            <span className="text-[8px] font-black text-slate-400 tracking-[0.2em] uppercase">Yönetim Paneli</span>
        </div>
        <button onClick={() => { setEditingId(null); setView(view === "EKLE" ? "LISTE" : "EKLE"); }} className="bg-green-700 w-12 h-12 rounded-2xl flex items-center justify-center text-white text-2xl font-black shadow-lg shadow-green-100">
            {view === "EKLE" ? "×" : "+"}
        </button>
      </div>

      {/* --- ÜST TAB MENÜSÜ --- */}
      {(view === "LISTE" || view === "MAGAZA") && (
        <div className="bg-white border-b sticky top-[81px] z-40 p-2 flex gap-2">
            <button 
                onClick={() => setView("LISTE")} 
                className={`flex-1 py-3 rounded-xl font-black text-[10px] uppercase transition-all ${view === 'LISTE' ? 'bg-green-700 text-white shadow-md' : 'bg-slate-50 text-slate-400'}`}
            >
                📦 Kargo Takip
            </button>
            <button 
                onClick={() => setView("MAGAZA")} 
                className={`flex-1 py-3 rounded-xl font-black text-[10px] uppercase transition-all ${view === 'MAGAZA' ? 'bg-orange-600 text-white shadow-md' : 'bg-slate-50 text-slate-400'}`}
            >
                🏪 Mağaza Satışı
            </button>
        </div>
      )}

      <div className="p-4 flex-1">
        
        {/* --- 1. LİSTELEME EKRANI --- */}
        {view === "LISTE" && (
          <div className="space-y-4">
            <div className="flex gap-2 overflow-x-auto no-scrollbar pb-2">
                {["HEPSİ", "BEKLEYEN", "TESLİM EDİLDİ", "EVDE YOK", "İADE"].map(f => (
                    <button 
                      key={f} 
                      onClick={() => setAktifFiltre(f)}
                      className={`px-5 py-2 rounded-xl text-[10px] font-black whitespace-nowrap transition-all border ${aktifFiltre === f ? 'bg-green-700 text-white border-green-700 shadow-md' : 'bg-white text-slate-400 border-slate-100'}`}
                    >
                      {f}
                    </button>
                ))}
            </div>

            {filtrelenmişList.map(s => (
              <div key={s.id} className="bg-white border border-slate-100 rounded-[2rem] flex flex-col gap-3 shadow-sm relative overflow-hidden">
                {s.atananPersonel ? (
                  <div className={`px-5 py-2 border-b flex justify-between items-center ${s.atananPersonel === 'MAĞAZA' ? 'bg-orange-50 border-orange-100' : 'bg-green-50 border-green-100'}`}>
                    <span className={`text-[9px] font-black uppercase italic ${s.atananPersonel === 'MAĞAZA' ? 'text-orange-700' : 'text-green-700'}`}>
                        {s.atananPersonel === 'MAĞAZA' ? '🏪 Yerinden Satış:' : '🚚 Atanan Şoför:'}
                    </span>
                    <span className={`text-[10px] font-black uppercase tracking-tighter ${s.atananPersonel === 'MAĞAZA' ? 'text-orange-800' : 'text-green-800'}`}>
                        {s.atananPersonel} {s.atananPlaka && `(${s.atananPlaka})`}
                    </span>
                  </div>
                ) : (
                  <div className="bg-slate-50 px-5 py-2 border-b border-slate-100">
                    <span className="text-[9px] font-black text-slate-400 uppercase italic">⚠️ Henüz Şoför Atanmadı</span>
                  </div>
                )}

                <div className="px-5 pt-2">
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="text-[10px] font-black text-green-600 uppercase mb-1">{s.ilce} / {s.koy}</p>
                      <h3 className="text-lg font-black uppercase text-slate-800 tracking-tight leading-none">{s.adSoyad}</h3>
                    </div>
                    <div className="text-right">
                      <p className="text-lg font-black text-slate-900">{(Number(s.tutar || 0) + Number(s.kargoUcreti || 0))} TL</p>
                      <span className={`text-[8px] font-black px-2 py-1 rounded-md ${s.durum === 'TESLİM EDİLDİ' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-600'}`}>{s.durum}</span>
                    </div>
                  </div>
                </div>

                <div className="px-5">
                  <div className="bg-slate-50 rounded-2xl p-3 border border-slate-100 text-[11px] font-bold leading-tight uppercase text-slate-600">
                    {s.aciklama || "Açıklama Belirtilmedi"}
                  </div>
                </div>

                <div className="px-5 pb-5 grid grid-cols-5 gap-2">
                  <button onClick={() => {setSeciliKargo(s); setView("ATA");}} className="col-span-2 bg-green-700 text-white py-4 rounded-2xl font-black text-[10px] uppercase italic shadow-md">
                      Şoför Seç
                  </button>
                  <button onClick={() => etiketBas(s)} className="col-span-1 bg-blue-600 text-white py-4 rounded-2xl font-black text-[12px] flex items-center justify-center shadow-md">
                    🖨️
                  </button>
                  <button onClick={() => kargoDuzenle(s)} className="col-span-1 bg-blue-50 text-blue-600 py-4 rounded-2xl font-black text-[10px] uppercase flex items-center justify-center border border-blue-100">
                    ✎
                  </button>
                  <button onClick={() => kargoIptalEt(s)} className="col-span-1 bg-red-50 text-red-600 py-4 rounded-2xl font-black text-[10px] uppercase flex items-center justify-center border border-red-100">
                    ✕
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* --- MAĞAZA SATIŞ EKRANI (YENİ) --- */}
        {view === "MAGAZA" && (
            <div className="p-2 animate-in slide-in-from-top duration-300 pb-32">
                <div className="bg-white rounded-[2.5rem] p-8 shadow-xl border-4 border-orange-100">
                    <div className="flex items-center gap-3 mb-6">
                        <span className="text-3xl">🏪</span>
                        <h2 className="text-xl font-black text-slate-800 uppercase leading-none">Hızlı Mağaza Kaydı</h2>
                    </div>
                    
                    <div className="space-y-4">
                        <input 
                            type="text" placeholder="Müşteri Adı (Zorunlu değil)" 
                            className="w-full p-5 bg-slate-50 rounded-2xl outline-none border border-slate-100 font-bold"
                            value={magazaForm.adSoyad}
                            onChange={e => setMagazaForm({...magazaForm, adSoyad: e.target.value.toUpperCase()})}
                        />
                        <input 
                            type="text" placeholder="Ürün / Not (Örn: 2 Adet 5L)" 
                            className="w-full p-5 bg-slate-50 rounded-2xl outline-none border border-slate-100 font-bold"
                            value={magazaForm.aciklama}
                            onChange={e => setMagazaForm({...magazaForm, aciklama: e.target.value.toUpperCase()})}
                        />
                        
                        <div className="grid grid-cols-2 gap-4">
                            <input 
                                type="number" placeholder="Tutar" 
                                className="w-full p-5 bg-slate-50 rounded-2xl outline-none border border-slate-100 font-black text-xl"
                                value={magazaForm.tutar}
                                onChange={e => setMagazaForm({...magazaForm, tutar: e.target.value})}
                            />
                            <select 
                                className="w-full p-5 bg-slate-50 rounded-2xl outline-none border border-slate-100 font-bold"
                                value={magazaForm.tahsilatTipi}
                                onChange={e => setMagazaForm({...magazaForm, tahsilatTipi: e.target.value})}
                            >
                                <option value="NAKİT">💵 NAKİT</option>
                                <option value="KART">💳 KART</option>
                                <option value="IBAN">🏦 IBAN</option>
                            </select>
                        </div>

                        <button 
                            onClick={magazaSatisiKaydet}
                            className="w-full bg-orange-600 text-white py-6 rounded-3xl font-black uppercase shadow-xl shadow-orange-200 mt-4 active:scale-95 transition-all"
                        >
                            Kaydı Tamamla
                        </button>
                    </div>
                </div>
            </div>
        )}

        {/* --- 2. EKLEME FORMU --- */}
        {view === "EKLE" && (
          <div className="bg-white p-6 rounded-[2.5rem] border border-green-100 space-y-4 shadow-xl">
            <h2 className="text-green-700 font-black italic uppercase text-lg mb-4">{editingId ? "Kaydı Güncelle" : "Yeni Gönderi Kaydı"}</h2>
            <input placeholder="ALICI AD SOYAD" className="w-full bg-slate-50 p-4 rounded-2xl border border-slate-100 font-black uppercase text-sm" value={form.adSoyad} onChange={e => setForm({...form, adSoyad: e.target.value.toUpperCase()})} />
            
            <div className="grid grid-cols-2 gap-2">
                <select className="bg-slate-50 p-4 rounded-2xl border border-slate-100 font-black text-xs" value={form.ilce} onChange={e => setForm({...form, ilce: e.target.value, koy: ""})}>
                    <option value="">İLÇE</option>
                    {Object.keys(KKTC_LISTE).map(il => <option key={il} value={il}>{il}</option>)}
                </select>
                <select className="bg-slate-50 p-4 rounded-2xl border border-slate-100 font-black text-xs" value={form.koy} onChange={e => setForm({...form, koy: e.target.value})}>
                    <option value="">KÖY/BÖLGE</option>
                    {(KKTC_LISTE[form.ilce] || []).map(k => <option key={k} value={k}>{k}</option>)}
                </select>
            </div>
            <textarea placeholder="TAM ADRES" className="w-full bg-slate-50 p-4 rounded-2xl border border-slate-100 font-bold text-xs h-20" value={form.adres} onChange={e => setForm({...form, adres: e.target.value.toUpperCase()})} />
            <input placeholder="ÜRÜN AÇIKLAMASI" className="w-full bg-slate-50 p-4 rounded-2xl border border-slate-100 font-bold uppercase text-xs" value={form.aciklama} onChange={e => setForm({...form, aciklama: e.target.value.toUpperCase()})} />
            <div className="grid grid-cols-2 gap-2">
                <input placeholder="TELEFON" className="bg-slate-50 p-4 rounded-2xl border border-slate-100 font-black text-sm" value={form.tel} onChange={e => setForm({...form, tel: e.target.value})} />
                <input placeholder="PAKET ADET" type="number" className="bg-slate-50 p-4 rounded-2xl border border-slate-100 font-black text-green-600 text-sm" value={form.paketAdet} onChange={e => setForm({...form, paketAdet: e.target.value})} />
            </div>
            <div className="grid grid-cols-2 gap-2">
                <input placeholder="ÜRÜN ₺" type="number" className="bg-slate-50 p-4 rounded-2xl border border-slate-100 font-black text-slate-800" value={form.tutar} onChange={e => setForm({...form, tutar: e.target.value})} />
                <input placeholder="KARGO ₺" type="number" className="bg-slate-50 p-4 rounded-2xl border border-slate-100 font-black text-slate-800" value={form.kargoUcreti} onChange={e => setForm({...form, kargoUcreti: e.target.value})} />
            </div>
            <button onClick={kargoKaydet} className="w-full bg-green-700 py-5 rounded-[2rem] font-black text-white text-lg shadow-xl uppercase italic">
                {editingId ? "GÜNCELLEMEYİ KAYDET" : "KAYDI TAMAMLA"}
            </button>
          </div>
        )}

        {/* --- 3. ŞOFÖR SEÇİM MODALI --- */}
        {view === "ATA" && seciliKargo && (
          <div className="fixed inset-0 bg-green-900/40 backdrop-blur-sm z-[200] p-6 flex flex-col justify-end">
             <div className="bg-white rounded-t-[3rem] p-8 shadow-2xl">
                <h2 className="text-slate-800 font-black text-center text-xl mb-1 uppercase italic">ŞOFÖR ATA</h2>
                <p className="text-green-600 text-center font-bold mb-8 uppercase text-[10px]">{seciliKargo.adSoyad}</p>
                <div className="space-y-4">
                    {Object.keys(SOFOR_EMAILLERI).map(sofor => (
                        <div key={sofor} className="bg-slate-50 border border-slate-100 p-4 rounded-3xl">
                            <p className="text-[9px] font-black text-slate-400 mb-3 text-center uppercase tracking-widest">{sofor}</p>
                            <div className="grid grid-cols-2 gap-2">
                                {["AJ 101 A", "JP 101"].map(plaka => (
                                    <button key={plaka} onClick={() => soforeAta(sofor, plaka)} className="bg-white border border-slate-200 py-4 rounded-2xl font-black text-slate-700 text-[11px]">
                                      {plaka}
                                    </button>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
                <button onClick={() => setView("LISTE")} className="mt-8 text-slate-400 font-black uppercase text-[10px] text-center w-full py-2">Vazgeç</button>
             </div>
          </div>
        )}
      </div>

      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-green-50 p-4 grid grid-cols-2 gap-4 shadow-lg z-50">
          <button onClick={() => setView("LISTE")} className={`py-4 rounded-2xl font-black text-[10px] uppercase italic ${view === 'LISTE' || view === 'MAGAZA' ? 'bg-green-700 text-white shadow-lg' : 'bg-slate-50 text-slate-400'}`}>📋 Kargolar</button>
          <button onClick={() => { setEditingId(null); setForm({ adSoyad: "", ilce: "", koy: "", adres: "", tel: "", paketAdet: "1", aciklama: "", tutar: "", kargoUcreti: "0" }); setView("EKLE"); }} className={`py-4 rounded-2xl font-black text-[10px] uppercase italic ${view === 'EKLE' ? 'bg-green-700 text-white shadow-lg' : 'bg-slate-50 text-slate-400'}`}>📝 Yeni Kayıt</button>
      </div>
    </div>
  );
}

export default DevayKargoPage;